import { FormattedCity } from "@website/ticket-ui/common/types";
import { DatepickerV2SelectedDateType } from "@website/ui-old/datepicker-v2";
import { useCallback, useEffect, useState } from "react";

export const useValidation = ({
  originItem,
  destinationItem,
  saleType,
  date
}: {
  originItem: FormattedCity | null;
  destinationItem: FormattedCity | null;
  saleType: string;
  date: DatepickerV2SelectedDateType;
}) => {
  const [originError, setOriginError] = useState<string>("");
  const [destinationError, setDestinationError] = useState<string>("");
  const [dateError, setDateError] = useState<string>("");

  useEffect(() => {
    setOriginError("");
  }, [originItem]);

  useEffect(() => {
    setDestinationError("");
  }, [destinationItem]);

  useEffect(() => {
    setDateError("");
  }, [date]);

  const submitValidationCheck = useCallback(() => {
    let hasError = false;
    if (!originItem) {
      setOriginError("لطفا مبدأ خود را انتخاب نمایید");
      hasError = true;
    }

    if (!destinationItem) {
      setDestinationError("لطفا مقصد خود را انتخاب نمایید");
      hasError = true;
    }

    if (originItem?.iataCode === destinationItem?.iataCode) {
      setDestinationError("مبدا و مقصد نمیتواند یکسان باشد");
      hasError = true;
    }

    if (saleType === "round-trip") {
      if (!date || !date[0] || !date[1]) {
        setDateError("لطفا تاریخ پرواز رفت و برگشت خود را مشخص کنید");
        hasError = true;
      }
    } else if (!date || !date[0]) {
      setDateError("لطفا تاریخ پرواز رفت خود را مشخص کنید");
      hasError = true;
    }

    if (hasError) {
      return false;
    }
    return true;
  }, [originItem, destinationItem, saleType, date]);

  return { originError, destinationError, dateError, submitValidationCheck };
};
